import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button, Card, Navbar, Nav, NavDropdown, Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube, FaChevronRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { message } from "antd";
import logoImage from '../../assets/image/jas-logo-wb.png';
import NRIHeader from '../../assets/image/NRI-Registration.png';
import VisitorHeader from '../../assets/image/visitor-header.png';
import useFetchData from '../../common/useFetchData';

const CustomDropdown = ({ title, items }) => {
    return (
        <NavDropdown
            title={<span className="custom-header-button">{title}</span>}
            id={`dropdown-${title.toLowerCase().replace(/\s/g, '-')}`}
            className="custom-dropdown"
        >
            {items.map((item, index) =>
                item.list ? (
                    <div key={index} className="dropdown-submenu">
                        <NavDropdown
                            title={
                                <span className="d-flex justify-content-between align-items-center w-100">
                                    {item.text}
                                    <FaChevronRight className="ml-2" />
                                </span>
                            }
                            id={`sub-dropdown-${item.text.toLowerCase().replace(/\s/g, '-')}`}
                            className="nested-dropdown"
                        >
                            {Object.entries(item.list).map(([key, value], i) => (
                                <NavDropdown.Item key={i} href={value.link}>
                                    {value.text}
                                </NavDropdown.Item>
                            ))}
                        </NavDropdown>
                    </div>
                ) : (
                    <NavDropdown.Item key={index} href={item.link}>
                        {item.text}
                    </NavDropdown.Item>
                )
            )}
        </NavDropdown>
    );
};

const VisitorRegistrationForm = ({ isNri = false }) => {
    const { showData } = useFetchData();
    const [formData, setFormData] = useState({
        name: '',
        company: '',
        email: '',
        mobile: '',
        isIndian: isNri ? false : true,
        country: isNri ? '' : 'India',
        state: '',
        city: '',
        address: '',
        pincode: '',
        gstNumber: '',
        passportNumber: '',
        passportExpiryDate: '',
        aadharCard: null,
        photo: null,
        // gstCertificate: null,
        categories: {
            gemstones: false,
            diamondJewellery: false,
            kundanMeena: false,
            goldJewellery: false,
            silverJewellery: false,
            coloredGemstones: false,
            ancillary: false,
            syntheticStones: false
        },
        otherCategories: ''
    });
    const [isNRI, setIsNRI] = useState(isNri);
    const [showError, setShowError] = useState('');
    const [duplicateError, setDuplicateError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [isEditable, setIsEditable] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const navItems = [
        {
            title: "HOME",
            type: "link",
            link: "https://jasjaipur.com"
        },
        {
            title: "ABOUT",
            type: "dropdown",
            items: [
                { text: "ABOUT JAS", link: "https://jasjaipur.com/about-jas/" },
                { text: "JEWELLERS ASSOCIATION", link: "https://jasjaipur.com/jewellers-asscoiation/" },
                { text: "COMMITTEE", link: "https://jasjaipur.com/committee/" }
            ]
        },
        {
            title: "VISITOR SERVICES",
            type: "dropdown",
            items: [
                { text: "BUYER'S GUIDE", link: "/visitor/registration" },
                {
                    text: "TRAVLES AND HOTELS", list: [
                        { text: "OFFICIAL HOTELS", link: "https://jasjaipur.com/official-hotels/" },
                        { text: "AIR INFO", link: "https://jasjaipur.com/air-info/" },
                        { text: "RAIL INFO", link: "https://jasjaipur.com/rail-info/" },
                        { text: "ROAD INFO", link: "https://jasjaipur.com/road-info/" },
                        { text: "RESTAURANT INFO", link: "https://jasjaipur.com/restaurant-info/" },
                    ], link: "/visitor/information"
                },
                {
                    text: "JAIPUR GUIDE", list: [
                        { text: "AT A GLANCE", link: "https://jasjaipur.com/at-a-glance" },
                        { text: "HISTORY", link: "https://jasjaipur.com/history" },
                        { text: "TOURIST SPOTS", link: "https://jasjaipur.com/tourist-spots" },
                    ], link: "/visitor/information"
                },
                { text: "VENUE", link: "/venue-location" }
            ]
        },
        {
            title: "EXHIBITOR SERVICES",
            type: "dropdown",
            items: [
                { text: "EXHIBITORS LOGIN", link: "/exhibitor/login" },
                { text: "EXHIBITORS LIST", link: "https://jasjaipur.com/exhibitors-list/" },
                { text: "FLOOR PLAN", link: "https://jasjaipur.com/floor-plan/" },
                { text: "EXHIBITOR MANUAL", link: "https://jasjaipur.com/wp-content/uploads/2026/04/exhibitor-manual.pdf" },
                {
                    text: "BOOTH LAYOUT", list: [
                        { text: "12 SQM JEWELLERY STALL", link: "https://jasjaipur.com/wp-content/uploads/2024/05/12-Sqm-JEWELLERY-STALL.pdf" },
                        { text: "24 SQM JEWELLERY STALL", link: "https://jasjaipur.com/wp-content/uploads/2024/05/24-Sqm-JEWELLERY-STALL.pdf" },
                        { text: "12 SQM GEMSTONE STALL", link: "https://jasjaipur.com/wp-content/uploads/2024/05/12-Sqm-GEMSTONE-STALL.pdf" },
                        { text: "24 SQM GEMSTONE STALL", link: "https://jasjaipur.com/wp-content/uploads/2024/05/24-Sqm-JEWELLERY-STALL.pdf" },
                    ], link: "/exhibitor/booth"
                },
                { text: "SPONSORSHIP OPPORTUNITY", link: "https://jasjaipur.com/wp-content/uploads/2023/05/Sponsorship-Oppourtinity-for-jas-23.pdf" },
            ]
        },
        {
            title: "VISITOR REGISTRATION",
            type: "link",
            link: "/visitor-registration"
        },
        {
            title: "JE AWARDS",
            type: "link",
            link: "https://jasjaipur.com/JEAwards"
        },
        {
            title: "GALLERY",
            type: "link",
            link: "https://jasjaipur.com/gallery"
        },
        {
            title: "PRESS ROOM",
            type: "link",
            link: "https://jasjaipur.com/press-room"
        },
        {
            title: "CONTACT US",
            type: "link",
            link: "https://jasjaipur.com/contact-us"
        },
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData({
            ...formData,
            categories: {
                ...formData.categories,
                [name]: checked
            }
        });
    };

    const handleRadioChange = (e) => {
        setFormData({
            ...formData,
            mobile: '',
            isIndian: e.target.id === 'indianResident',
            country: e.target.id === 'indianResident' ? 'India' : '',
            gstNumber: '',
            company: '',
            address: '',
            state: '',
            city: '',
            pincode: '',
        });

        setIsNRI(!(e.target.id === 'indianResident'));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        const file = files[0];

        if (file) {
            const allowedExtensions = ['jpg', 'jpeg', 'png'];
            const fileExtension = file.name.split('.').pop().toLowerCase();
            const isValidExtension = allowedExtensions.includes(fileExtension);
            const isValidMimeType = ['image/jpeg', 'image/png'].includes(file.type);

            if (!isValidExtension || !isValidMimeType) {
                message.error('Only JPEG, JPG, and PNG files are allowed.');
                e.target.value = ''; // Clear the input field
                setFormData(prev => ({
                    ...prev,
                    [name]: null
                }));
                return;
            }
        }

        setFormData({
            ...formData,
            [name]: file
        });
    };

    const handleMobileNoChange = (e) => {
        const { name, value } = e.target;
        const numericValue = value.replace(/\D/g, "");

        setFormData(prev => ({
            ...prev,
            [name]: numericValue
        }));
    };

    const handleMobileBlur = () => {
        const { mobile, isIndian } = formData;

        if (isIndian) {
            if (mobile.length !== 10) {
                message.error('Mobile number must be 10 digits');
                return;
            }
        }

        if (mobile.length > 8) {
            axios.get(`${process.env.REACT_APP_API_END_POINT}/check-phone-number-existance/${mobile}`)
                .then((resData) => {
                    if (resData.data.found) {
                        setDuplicateError("true");
                        message.error(`This mobile number is already registered`);
                    } else {
                        setDuplicateError(null);
                    }
                })
                .catch((error) => {
                    console.error('Error checking mobile:', error);
                });
        }
    };

    const handleEmailChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            email: value,
        });

        const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

        if (!emailPattern.test(value)) {
            setEmailError("Invalid email format");
        } else {
            setEmailError("");
        }
    };

    const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    function checkRegex(input) {
        return regex.test(input);
    }

    function convertToUpperCase(input) {
        return input.replace(/[a-z]/gi, (char) => char.toUpperCase());
    }

    const handleGstNumberChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: convertToUpperCase(value)
        });

        if (checkRegex(value)) {
            setShowError("");
        } else {
            setShowError("Provide Valid GSTIN");
        }
    };

    function validateGstNumber(gst_number) {
        if (gst_number && (gst_number.length !== 15 || !checkRegex(gst_number))) {
            return false;
        }

        return true;
    }

    useEffect(() => {
        if (formData.gstNumber.length === 15 && checkRegex(formData.gstNumber)) {
            axios
                .get(
                    `${process.env.REACT_APP_API_END_POINT}/check-gst-validation/${formData.gstNumber}`
                )
                .then((resData) => {
                    if (resData.data.flag === false) {
                        setShowError(resData.data.message);
                        return;
                    }

                    setIsEditable(true);
                    setShowError("");
                    setFormData({
                        ...formData,
                        company: resData.data.company,
                        address: resData.data.address,
                        city: resData.data.city,
                        state: resData.data.state,
                        pincode: resData.data.pincode,
                    })
                }).catch((err) => {
                    setShowError("Facing Issue While Fetching")
                })
        }
    }, [formData.gstNumber]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (duplicateError) {
            message.error('This mobile number is already registered.');
            setIsLoading(false);
            return;
        }

        console.log('Form submitted:', formData);

        if (!formData.name) {
            message.error('Name is mandatory');
            setIsLoading(false);
        } else if (!formData.mobile) {
            message.error('Mobile number is mandatory')
            setIsLoading(false);
        } else if (!formData.email) {
            message.error('Email is mandatory')
            setIsLoading(false);
        } else if (emailError !== '') {
            message.error('Please enter a valid Email address, e.g. abc@xyz.co');
            setIsLoading(false);
        } else if (!formData.company) {
            message.error('Company is mandatory')
            setIsLoading(false);
        } else if (!formData.country) {
            message.error('Country is mandatory')
            setIsLoading(false);
        } else if (!formData.state) {
            message.error('State is mandatory')
            setIsLoading(false);
        } else if (!formData.city) {
            message.error('City is mandatory')
            setIsLoading(false);
        } else if (!formData.address) {
            message.error('Address is mandatory')
            setIsLoading(false);
        } else if (!formData.pincode) {
            message.error('Pincode is mandatory')
            setIsLoading(false);
        } else if (!formData.gstNumber && !isNRI) {
            message.error('GST Number is mandatory')
            setIsLoading(false);
        } else if (!validateGstNumber(formData.gstNumber)) {
            message.error('Please enter a valid GST Number')
            setIsLoading(false);
        } else if (!formData.aadharCard) {
            message.error(`${isNRI ? 'ID Proof' : 'Aadhar Card'} is mandatory`)
            setIsLoading(false);
        } else if (!formData.photo) {
            message.error('Photo is mandatory')
            setIsLoading(false);
        } else {
            const allowedExtensions = ['jpg', 'jpeg', 'png'];

            const checkFile = (file) => {
                if (!file) return false;
                const extension = file.name.split('.').pop().toLowerCase();
                const isValidMimeType = ['image/jpeg', 'image/png'].includes(file.type);
                return allowedExtensions.includes(extension) && isValidMimeType;
            };

            if (!checkFile(formData.aadharCard) || !checkFile(formData.photo)) {
                message.error('Please upload valid JPEG, JPG, or PNG files.');
                return;
            }

            const jaipurRegex = /\bjaipur\b/i;
            if (formData.city && jaipurRegex.test(formData.city.trim())) {
                message.error('Jaipur is not allowed as city');
                setIsLoading(false);
                return;
            }

            if (formData.isIndian && formData.mobile.length !== 10) {
                message.error('Mobile number must be 10 digits');
                setIsLoading(false);
                return;
            }

            if (!formData.isIndian) {
                if (!formData.passportNumber) {
                    setIsLoading(false);
                    return message.error('Passport number is mandatory');
                }

                if (!formData.passportExpiryDate) {
                    setIsLoading(false);
                    return message.error('Passport expiry date is mandatory');
                }
            }
            const requestData = new FormData();
            requestData.append("visitor_name", formData.name);
            requestData.append("company_name", formData.company);
            requestData.append("email", formData.email);
            requestData.append("mobile_number", formData.mobile);
            requestData.append("country", formData.country);
            requestData.append("city", formData.city);
            requestData.append("state", formData.state);
            requestData.append("street_address", formData.address);
            requestData.append("postal_code", formData.pincode);
            requestData.append("gst_number", formData.gstNumber);
            requestData.append("passport_number", formData.passportNumber);
            requestData.append("passport_expiry_date", formData.passportExpiryDate);
            requestData.append("photo", formData.photo);
            requestData.append("id_proof_front", formData.aadharCard);
            // requestData.append("gst_certificate", formData.gstCertificate);

            const selectedCategories = [];
            Object.entries(formData.categories).forEach(([key, value]) => {
                if (value === true) {
                    selectedCategories.push({ name: key });
                }
            });

            if (formData.otherCategories && formData.otherCategories.trim() !== '') {
                selectedCategories.push({ name: formData.otherCategories.trim() });
            }

            if (selectedCategories.length === 0) {
                setIsLoading(false);
                return message.error('Categories are mandatory, Please select one or multiple or can type specific category.');
            }

            requestData.append("category", "visitor");
            requestData.append("interest_category", JSON.stringify(selectedCategories));

            axios
                .post(
                    `${process.env.REACT_APP_API_END_POINT}/visitor-registration`,
                    requestData,
                )
                .then((res) => {
                    setIsLoading(false);
                    const value = res.data.message;
                    if (value === "Buyer" || value === "Visitor") {
                        message.error(`This Person Is Already Presented As ${value}`);
                    } else {
                        message.success('Visitor added successfully, Thank you for filling the form.');
                        setIsSubmitted(true);
                    }
                })
                .catch((err) => {
                    setIsLoading(false);
                    message.error('An error occurred. Please try again.');
                });
        }
    };

    return (
        <div className="visitor-registration-page">
            <div className="bg-amber-700 py-1">
                <Container fluid>
                    <Row className="align-items-center">
                        <Col xs={6} md={3} lg={2}>
                            <Navbar.Brand href="https://jasjaipur.com" className="text-white d-flex align-items-center mr-5">
                                <img src={logoImage} width={'120px'} />
                            </Navbar.Brand>
                        </Col>

                        <Col xs={6} md={9} lg={10}>
                            <Navbar expand="lg" className="p-0 justify-content-end">
                                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                                <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
                                    <Nav>
                                        {/* {navItems.map((item, index) => (
                                            item.type === "dropdown" ? (
                                                <CustomDropdown
                                                    key={index}
                                                    title={item.title}
                                                    items={item.items}
                                                />
                                            ) : (
                                                <Nav.Link
                                                    key={index}
                                                    href={item.link}
                                                    className="custom-header-button"
                                                >
                                                    {item.title}
                                                </Nav.Link>
                                            )
                                        ))} */}

                                        <Button
                                            style={{ backgroundColor: 'rgb(33,37,41)', border: 'none' }}
                                            onClick={() => window.location.href = 'https://jasjaipur.com'}
                                        >
                                            Go Back
                                        </Button>
                                    </Nav>
                                </Navbar.Collapse>
                            </Navbar>
                        </Col>
                    </Row>
                </Container>

                <style jsx>{`
                    .bg-amber-700 {
                        background-color: #b98b51;
                        height: 60px;
                    }

                    .navbar-expand-lg .navbar-nav {
                        gap: 0px;
                    }

                    .custom-header-button {
                        color: white;
                        font-weight: 600;
                        font-size: 14px;
                    }

                    .custom-header-button:hover {
                        color: white;
                    }

                    .custom-dropdown .dropdown-toggle::after {
                        color: white;
                    }

                    .custom-dropdown .dropdown-menu {
                        border-radius: 0;
                        margin-top: 0;
                        border: none;
                        box-shadow: 0 4px 8px rgba(0,0,0,0.1);
                    }

                    .nav-link, .dropdown-toggle {
                        font-size: 0.85rem;
                        letter-spacing: 0.5px;
                    }

                    .nav-link {
                        font-weight: 600;
                        font-size: 14px;
                        margin-left: 10px;
                    }
                `}</style>
            </div>

            {isNRI ? (
                <img src={NRIHeader} width={'100%'} />
            ) : (
                <img src={VisitorHeader} width={'100%'} />
            )}

            {isSubmitted ? (
                <Container fluid className='py-5 px-5' style={{ backgroundColor: '#3a3a3a', minHeight: '500px' }}>
                    <Row className="justify-content-center align-items-center">
                        <Col md={8} className="text-center text-white py-5">
                            <div className="mb-4">
                                <h1 style={{ color: '#D6A955', fontSize: '3.5rem', fontWeight: 'bold' }}>Thank You!</h1>
                            </div>
                            <h3 className="mb-4 text-white" style={{ color: '#ffffff' }}>Your registration has been submitted successfully.</h3>
                            <Button
                                variant="warning"
                                className="px-5 py-3 text-white fw-bold shadow-sm"
                                style={{
                                    backgroundColor: '#D6A955',
                                    borderColor: '#D6A955',
                                    borderRadius: '30px',
                                    fontSize: '1.2rem',
                                    transition: 'transform 0.2s'
                                }}
                                onClick={() => window.location.href = 'https://jasjaipur.com'}
                            >
                                Go Back to Home
                            </Button>
                        </Col>
                    </Row>
                </Container>
            ) : showData && showData.visitor !== "active" ? (
                <Container fluid className='py-5 px-5' style={{ backgroundColor: '#3a3a3a', minHeight: '500px' }}>
                    <Row className="justify-content-center align-items-center">
                        <Col md={8} className="text-center text-white py-5">
                            <div className="mb-4">
                                <h1 style={{ color: '#D6A955', fontSize: '3.5rem', fontWeight: 'bold' }}>Portal is Closed</h1>
                            </div>
                            <h3 className="mb-4 text-white" style={{ color: '#ffffff' }}>Please contact +91 8619192820 for further assistance.</h3>
                            <Button
                                variant="warning"
                                className="px-5 py-3 text-white fw-bold shadow-sm"
                                style={{
                                    backgroundColor: '#D6A955',
                                    borderColor: '#D6A955',
                                    borderRadius: '30px',
                                    fontSize: '1.2rem',
                                    transition: 'transform 0.2s'
                                }}
                                onClick={() => window.location.href = 'https://jasjaipur.com'}
                            >
                                Go Back to Home
                            </Button>
                        </Col>
                    </Row>
                </Container>
            ) : (
                <Container fluid className='py-4 px-5' style={{ backgroundColor: '#3a3a3a' }}>
                    <Row>
                        <Col lg={8} className="text-white">
                            <div className="mb-4">
                                <p className="fw-bold mb-1 text-white">Note** Application will not be applicable for Jaipur Residents</p>
                                <p className="fw-bold mb-1 text-white">Note** The registration confirmation is subject to the approval by the organising committee</p>
                                <p className="fw-bold text-white">Note** The address field value will be used to courier the physical badges.</p>
                            </div>

                            <Form onSubmit={handleSubmit} className='px-4'>
                                <Row className="mb-3">
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <div className="d-flex gap-4">
                                                {isNri ? (
                                                    <Form.Check
                                                        type="radio"
                                                        label={<span style={{ color: '#ffffff', fontWeight: 'bold' }}>NRI</span>}
                                                        name="residenceType"
                                                        id="nri"
                                                        checked={true}
                                                        readOnly
                                                    />
                                                ) : (
                                                    <>
                                                        <Form.Check
                                                            type="radio"
                                                            label={<span style={{ color: '#ffffff' }}>Indian Resident</span>}
                                                            name="residenceType"
                                                            id="indianResident"
                                                            checked={formData.isIndian}
                                                            onChange={handleRadioChange}
                                                        />
                                                        <Form.Check
                                                            type="radio"
                                                            label={<span style={{ color: '#ffffff' }}>NRI</span>}
                                                            name="residenceType"
                                                            id="nri"
                                                            checked={!formData.isIndian}
                                                            onChange={handleRadioChange}
                                                        />
                                                    </>
                                                )}
                                            </div>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Your Name <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                placeholder="Enter Name"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                                required
                                                className="border-warning custom-input"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Mobile <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="tel"
                                                name="mobile"
                                                placeholder="Enter Mobile"
                                                value={formData.mobile}
                                                onChange={handleMobileNoChange}
                                                onBlur={handleMobileBlur}
                                                minLength={formData.isIndian ? 10 : 7}
                                                required
                                                className="border-warning custom-input"
                                            />
                                            {duplicateError && <span className='text-danger'>This Number is already exists</span>}
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Email <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                placeholder="Enter Email"
                                                value={formData.email}
                                                onChange={handleEmailChange}
                                                required
                                                className="border-warning custom-input"
                                            />
                                            {emailError && <span className='text-danger'>{emailError}</span>}
                                        </Form.Group>
                                    </Col>
                                    {!isNRI &&
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>GST Number <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="gstNumber"
                                                    placeholder="Enter GST Number"
                                                    value={formData.gstNumber}
                                                    onChange={handleGstNumberChange}
                                                    required
                                                    className="border-warning custom-input"
                                                />
                                                {showError !== '' && <span className='text-danger'>{showError}</span>}
                                            </Form.Group>
                                        </Col>
                                    }
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Company <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="company"
                                                placeholder="Enter Company"
                                                value={formData.company}
                                                onChange={handleInputChange}
                                                required
                                                disabled={isEditable}
                                                className="border-warning custom-input"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Country <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="country"
                                                placeholder="Enter Country"
                                                value={formData.country}
                                                onChange={handleInputChange}
                                                required
                                                disabled={isEditable}
                                                className="border-warning custom-input"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>State <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="state"
                                                placeholder="Enter State"
                                                value={formData.state}
                                                onChange={handleInputChange}
                                                required
                                                className="border-warning custom-input"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>City <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="city"
                                                placeholder="Enter City"
                                                value={formData.city}
                                                onChange={handleInputChange}
                                                required
                                                disabled={isEditable}
                                                className="border-warning custom-input"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Address <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="address"
                                                placeholder="Enter Address"
                                                value={formData.address}
                                                onChange={handleInputChange}
                                                required
                                                className="border-warning custom-input"
                                            />
                                            <Form.Text className="text-danger">
                                                The above address will be used to courier the physical badges.
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Pincode <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type={isNRI ? "text" : "number"}
                                                name="pincode"
                                                placeholder="Enter pincode"
                                                value={formData.pincode}
                                                onChange={handleInputChange}
                                                required
                                                disabled={isEditable}
                                                className="border-warning custom-input"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {isNRI &&
                                    <Row className="mb-3">
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Passport Number {isNRI && <span className="text-danger">*</span>}</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="passportNumber"
                                                    placeholder="Enter Passport Number"
                                                    value={formData.passportNumber}
                                                    onChange={handleInputChange}
                                                    required={isNRI}
                                                    className="border-warning custom-input"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Passport Expiry Date {isNRI && <span className="text-danger">*</span>}</Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    name="passportExpiryDate"
                                                    value={formData.passportExpiryDate}
                                                    onChange={handleInputChange}
                                                    placeholder="dd/mm/yyyy"
                                                    required={isNRI}
                                                    className="border-warning custom-input"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                }

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{isNRI ? 'ID Proof' : 'Aadhar card'} <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="file"
                                                name="aadharCard"
                                                onChange={handleFileChange}
                                                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                                required
                                                className="border-warning custom-input"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Upload Photo <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="file"
                                                name="photo"
                                                onChange={handleFileChange}
                                                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                                required
                                                className="border-warning custom-input"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className="mb-4">
                                    <h5>What categories are you interested in? <span className="text-danger">*</span></h5>
                                    <Row className="mt-3 mb-3">
                                        <Col md={6}>
                                            <Form.Check
                                                type="checkbox"
                                                label="Gemstones"
                                                name="gemstones"
                                                checked={formData.categories.gemstones}
                                                onChange={handleCheckboxChange}
                                                className="mb-2"
                                            />
                                            <Form.Check
                                                type="checkbox"
                                                label="Kundan Meena (jadau) Jewellery"
                                                name="kundanMeena"
                                                checked={formData.categories.kundanMeena}
                                                onChange={handleCheckboxChange}
                                                className="mb-2"
                                            />
                                            {/* <Form.Check
                                                type="checkbox"
                                                label="Silver Jewellery"
                                                name="silverJewellery"
                                                checked={formData.categories.silverJewellery}
                                                onChange={handleCheckboxChange}
                                                className="mb-2"
                                            /> */}
                                            {/* <Form.Check
                                                type="checkbox"
                                                label="Ancillary"
                                                name="ancillary"
                                                checked={formData.categories.ancillary}
                                                onChange={handleCheckboxChange}
                                                className="mb-2"
                                            /> */}

                                              <Form.Check
                                                type="checkbox"
                                                label="Diamond & Gemstone Jewellery"
                                                name="diamondJewellery"
                                                checked={formData.categories.diamondJewellery}
                                                onChange={handleCheckboxChange}
                                                className="mb-2"
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <Form.Check
                                                type="checkbox"
                                                label="Gold Jewellery"
                                                name="goldJewellery"
                                                checked={formData.categories.goldJewellery}
                                                onChange={handleCheckboxChange}
                                                className="mb-2"
                                            />
                                            <Form.Check
                                                type="checkbox"
                                                label="Colored Gemstones"
                                                name="coloredGemstones"
                                                checked={formData.categories.coloredGemstones}
                                                onChange={handleCheckboxChange}
                                                className="mb-2"
                                            />
                                            <Form.Check
                                                type="checkbox"
                                                label="Synthetic Stones"
                                                name="syntheticStones"
                                                checked={formData.categories.syntheticStones}
                                                onChange={handleCheckboxChange}
                                                className="mb-2"
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mb-4">
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Specify others, if any</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="otherCategories"
                                                    value={formData.otherCategories}
                                                    onChange={handleInputChange}
                                                    className="border-warning custom-input"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>

                                <div className="mb-5">
                                    <Button
                                        variant="warning"
                                        type="submit"
                                        className="px-4 py-2 text-white"
                                        style={{ backgroundColor: '#D6A955', borderColor: '#D6A955', borderRadius: '20px' }}
                                        disabled={isLoading}
                                    >
                                        {isLoading ? (
                                            <>
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                />
                                                <span className="ms-2">Submitting...</span>
                                            </>
                                        ) : (
                                            'Submit'
                                        )}
                                    </Button>
                                </div>
                            </Form>
                        </Col>

                        <Col lg={4}>
                            <div className="text-center mb-4">
                                <Card className="custom-side-card">
                                    <Card.Body>
                                        <div className="mb-3">
                                            <h5>
                                                <Link to="https://jasjaipur.com/at-a-glance" className="text-decoration-none text-dark">At a Glance</Link> /{' '}
                                                <Link to="https://jasjaipur.com/history" className="text-decoration-none text-dark">History</Link> /{' '}
                                                <Link to="https://jasjaipur.com/tourist-spots" className="text-decoration-none text-dark">Tourist Spots</Link> /{' '}
                                                <Link to="https://jasjaipur.com/entertainment" className="text-decoration-none text-dark">Entertainment</Link>
                                            </h5>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>

                            <div className="text-center mb-4">
                                <Card className="custom-side-card">
                                    <Card.Body>
                                        <div className="mb-3">
                                            <h5>
                                                <Link to="https://jasjaipur.com/official-hotels" className="text-decoration-none text-dark">Official Hotels</Link> /{' '}
                                                <Link to="https://jasjaipur.com/air-info" className="text-decoration-none text-dark">Air Info</Link> /{' '}
                                                <Link to="https://jasjaipur.com/rail-info" className="text-decoration-none text-dark">Rail Info</Link> /{' '}
                                                <Link to="https://jasjaipur.com/road-info" className="text-decoration-none text-dark">Road Info</Link>
                                            </h5>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>

                            <div className="text-center mb-4">
                                <Card className="custom-side-card">
                                    <Card.Body>
                                        <div className="mb-3">
                                            <h5>
                                                <Link to="https://jasjaipur.com/restaurant-info" className="text-decoration-none text-dark">Restaurant Info</Link> /{' '}
                                                <Link to="https://jasjaipur.com/venue" className="text-decoration-none text-dark">Venue</Link>
                                            </h5>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>
                        </Col>
                    </Row>
                </Container>
            )}

            <footer className="bg-dark text-white pt-5 pb-3">
                <Container>
                    <Row className="mb-4">
                        <Col lg={5} className="mb-4">
                            <div className="mb-3">
                                <img src={logoImage} width={'150px'} />
                            </div>
                            <p className='text-white' style={{ width: "300px" }}>
                                Initiated by the Jewellers Association, Jaipur, JAS is India's top-of-the-line gemstone and jewellery show.
                            </p>
                        </Col>

                        <Col lg={3} className="mb-4">
                            <h5 className="mb-3">QUICK LINKS</h5>
                            <ul className="list-unstyled">
                                <li className="mb-2"><a href="https://jasjaipur.com/" className="text-white text-decoration-none">Home</a></li>
                                <li className="mb-2"><a href="https://jasjaipur.com/about-jas/" className="text-white text-decoration-none">About us</a></li>
                                <li className="mb-2"><a href="https://jasjaipur.com/gallery/" className="text-white text-decoration-none">Gallery</a></li>
                                <li className="mb-2"><a href="https://jasjaipur.com/press-room/" className="text-white text-decoration-none">Press room</a></li>
                                <li className="mb-2"><a href="https://jasjaipur.com/contact-us/" className="text-white text-decoration-none">Contact us</a></li>
                            </ul>
                        </Col>

                        <Col lg={3}>
                            <h5 className="mb-3">CONNECT WITH US</h5>
                            <address className="text-white">
                                252, Jewellers Association Building,<br />
                                Johari Bazar, Jaipur, Rajasthan, Pincode-302003<br />
                                <a href="mailto:info@jasjaipur.com" className="text-white text-decoration-none">info@jasjaipur.com</a>
                            </address>

                            <div className="d-flex gap-2 mt-3">
                                <a href="https://www.facebook.com/jasrajasthan/" className="btn btn-secondary btn-sm rounded-circle">
                                    <FaFacebookF />
                                </a>
                                <a href="https://www.instagram.com/jasrajasthan/" className="btn btn-secondary btn-sm rounded-circle">
                                    <FaInstagram />
                                </a>
                                <a href="https://x.com/jas_rajasthan" className="btn btn-secondary btn-sm rounded-circle">
                                    <FaTwitter />
                                </a>
                                <a href="https://www.youtube.com/channel/UCiwv7f9NNAOk3TRIcJqTo0A" className="btn btn-secondary btn-sm rounded-circle">
                                    <FaYoutube />
                                </a>
                            </div>
                        </Col>
                    </Row>

                    <hr className="border-secondary" />

                    <Row className="align-items-center">
                        <Col md={4} className="text-center text-md-start mb-3 mb-md-0">
                            <small>© Copyright {process.env.REACT_APP_ORGANIZER_NAME} 2026. All Rights Reserved</small>
                        </Col>
                        <Col md={4} className="text-center mb-3 mb-md-0">
                            <small>Designed by {process.env.REACT_APP_ORGANIZER_NAME}</small>
                        </Col>
                        <Col md={4} className="text-center text-md-end">
                            <small>Developed by {process.env.REACT_APP_ORGANIZER_NAME}</small>
                        </Col>
                    </Row>
                </Container>
            </footer>

            <style jsx>{`
                .visitor-registration-page {
                    font-family: 'Arial', sans-serif;
                }
                .header-bg {
                    background-color: #8a6d3b;
                }
                .border-warning {
                    border-color: #D6A955 !important;
                }
                .btn-warning {
                    background-color: #D6A955;
                    border-color: #D6A955;
                }
                .text-warning {
                    color: #D6A955 !important;
                }
                .custom-input {
                    background-color: #3a3a3a !important;
                    color: white !important;
                    border-color: #ffc107;
                }
                .custom-input::placeholder {
                    color: white !important;
                    opacity: 0.8;
                }
                .custom-side-card {
                    background-color: transparent !important;
                    color: white;
                    border-color: #D6A955;
                    border-radius: 2px;
                }
                .card-body div h5 a {
                    color: white !important;
                }
                .custom-dropdown .dropdown-submenu {
                    position: relative;
                }
                .custom-dropdown .nested-dropdown .dropdown-menu {
                    top: 0;
                    left: 100%;
                }
                .custom-dropdown .dropdown-menu {
                    border-radius: 0;
                    margin-top: 0;
                    border: none;
                    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
                }
                .dropdown-submenu > .dropdown-menu {
                    display: none;
                    position: absolute;
                    left: 100%;
                    top: 0;
                }
                .dropdown-submenu:hover > .dropdown-menu {
                    display: block;
                }
                .dropdown-submenu .dropdown-toggle::after {
                    margin-left: 0.5em;
                }
            `}</style>
        </div>
    );
};

export default VisitorRegistrationForm;
